<template>
  <b-modal
    id="edit-page-modal"
    class="custom-modal"
    title="Edit Page"
    size="lg"
    centered
    no-close-on-backdrop
    @shown="load"
  >
    <b-form>
      <b-row no-gutters class="mb-2">
        <b-col sm="12" md="3">
          <h6 class="primary-label">Page Settings</h6>
        </b-col>
        <b-col v-if="pageDetails">
          <b-row>
            <b-col>
              <b-form-group label-for="input-page-name-2">
                <div slot="label" class="secondary-label">Page Name</div>
                <b-input
                  id="input-page-name-2"
                  type="text"
                  v-model="inputPageName"
                  ref="inputPageName"
                  placeholder="Enter Title"
                  :maxlength="maxInputPageNameLength"
                  @keypress.native="filterAlphaNumericPunctuations"
                >
                </b-input>
                <b-form-invalid-feedback :force-show="!!inputPageNameError">
                  {{ inputPageNameError }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group>
                <div slot="label" class="secondary-label">
                  Show Previous Button?
                </div>
                <b-form-radio-group
                  v-model="inputHidePreviousButton"
                  :options="optionsBool"
                >
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <b-container fluid>
        <b-row>
          <b-col xs="12" md="4" class="mb-3 mb-md-0">
            <b-btn
              variant="ghost"
              class="btn-block btn-cancel"
              @click="$root.$emit('bv::hide::modal', 'edit-page-modal')"
            >
              Cancel
            </b-btn>
          </b-col>
          <b-col xs="12" md="4" class="ml-md-auto text-md-right">
            <b-btn variant="primary" class="btn-block" @click="validate">
              Save
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "EditPageModal",
  data() {
    return {
      maxInputPageNameLength: 50,
      optionsBool: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      inputPageName: "",
      inputHidePreviousButton: true,
      inputPageNameError: "",
    };
  },
  computed: {
    ...mapState("surveys", ["pageDetails"]),
  },
  props: ["pageId"],
  methods: {
    ...mapActions("surveys", ["getPageDetails", "updatePage"]),
    validate() {
      this.inputPageNameError = "";

      if (!this.inputPageName)
        this.inputPageNameError = "Page name is required";

      if (
        this.inputPageName &&
        this.isNotAlphaNumericPunctuations(this.inputPageName)
      )
        this.inputPageNameError =
          "Only alpha numeric with punctuation characters are allowed";

      if (!this.inputPageNameError) this.update();
      else notification.warning("Oops, cannot update page.");
    },
    isNotAlphaNumericPunctuations(input) {
      return /[^A-Za-z0-9 ,.!?'":()\s\-]+/g.test(input);
    },
    filterAlphaNumericPunctuations(e) {
      if (this.isNotAlphaNumericPunctuations(String.fromCharCode(e.keyCode)))
        e.preventDefault();
    },
    update() {
      this.inputPageNameError = "";

      this.updatePage({
        pageName: this.inputPageName,
        hidePreviousButton: !this.inputHidePreviousButton,
        pageId: this.pageId,
        surveyId: this.$route.params.uuid,
      });
      this.inputPageName = "";
      this.inputHidePreviousButton = true;
      this.inputPageNameError = "";
      this.$root.$emit("bv::hide::modal", "edit-page-modal");
    },
    load() {
      this.getPageDetails(this.pageId).then(() => {
        if (this.pageDetails) {
          const { page_name, hide_prev_button } = this.pageDetails;

          this.inputPageName = page_name;
          this.inputHidePreviousButton = !Boolean(hide_prev_button);
        }
      });
    },
  },
};
</script>

<style>
</style>